
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LayoutMenuMain extends Vue {
  @Prop({ required: true }) to!: string;

  get isActualRouteName() {
    return this.$route.name !== this.to;
  }
}
